import {
  AdGraphCrownJewelNodePropertiesSchema,
  AdGraphKnownNodePropertiesSchema,
  type AdGraphCrownJewelNodePropertiesDto,
  type AdGraphKnownNodePropertiesDto,
  type AdGraphNodeDto,
} from './ad-graph.schema';

export const parseAdGraphKnownNodeProperties = (
  value: AdGraphNodeDto['properties'],
): AdGraphKnownNodePropertiesDto | null => {
  const parsed = AdGraphKnownNodePropertiesSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
};

export const parseAdGraphCrownJewelNodeProperties = (
  value: AdGraphNodeDto['properties'],
): AdGraphCrownJewelNodePropertiesDto | null => {
  const parsed = AdGraphCrownJewelNodePropertiesSchema.safeParse(value);
  return parsed.success ? parsed.data : null;
};
